module.exports = __webpack_public_path__ + "static/carbon-e8e9938c048b2da494f10491fde7964e.jpg";